import { HuntStatsBar } from '@wehunt/ui'
import { useHuntStats } from './useHuntStats'

export interface HuntStatsProps {
  onViewInvitations?: () => void
  onViewUpcoming?: () => void
  onViewEnded?: () => void
}

export function HuntStats({ onViewInvitations, onViewUpcoming, onViewEnded }: HuntStatsProps) {
  const { data, isLoading } = useHuntStats()
  return (
    <HuntStatsBar
      pendingInvitations={data?.pendingInvitations ?? 0}
      upcomingHunts={data?.upcomingHunts ?? 0}
      endedHunts={data?.endedHunts ?? 0}
      harvestToDate={data?.harvestToDate ?? 0}
      harvestLoading={isLoading}
      onViewInvitations={onViewInvitations}
      onViewUpcoming={onViewUpcoming}
      onViewEnded={onViewEnded}
    />
  )
}
